import { useMemo } from "react";

import {
  acceptAction,
  declineAction
} from "b2b/components/common-grid-columns";
import * as COLUMNS_AVAILABLE from "b2b/components/zadosti-grid-columns/columnsAvailable";
import { isActionsByStavName } from "b2b/components/zadosti-odbaveni-grid/utils";

export default function useColumns({ handleClickAccept, handleClickDecline }) {
  const columns = [
    COLUMNS_AVAILABLE.zdrojNazev(),
    COLUMNS_AVAILABLE.termin(),
    COLUMNS_AVAILABLE.kolize(),
    COLUMNS_AVAILABLE.fixni(),
    COLUMNS_AVAILABLE.zadavatelZakaznikNazev(),
    COLUMNS_AVAILABLE.doplnkoveSluzby(),
    COLUMNS_AVAILABLE.datumVytvoreni(),
    COLUMNS_AVAILABLE.stav(),
    {
      ...acceptAction(handleClickAccept),
      renderable: ({ dataRow }) => isActionsByStavName(dataRow)
    },
    {
      ...declineAction(handleClickDecline),
      renderable: ({ dataRow }) => isActionsByStavName(dataRow)
    }
  ];
  return useMemo(() => [columns], [handleClickAccept, handleClickDecline]);
}
